module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('loadable', {
    staticClass: "delegations mt-5",
    attrs: {
      "loading": _vm.isBusy,
      "size": "small"
    }
  }, [(!_vm.delegation) ? [(_vm.delegations && _vm.delegations.length > 0) ? _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-subheader', [_vm._v(_vm._s(_vm.$t('delegations.title')))]), _vm._v(" "), _vm._l((_vm.delegations), function(delegation) {
    return _c('v-list-tile', {
      key: delegation._self,
      on: {
        "click": function($event) {
          _vm.select(delegation)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("open_in_browser")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(delegation.company.name))])], 1)], 1)
  })], 2) : _vm._e()] : [_c('v-layout', {
    staticClass: "active-delegation",
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "px-2": ""
    }
  }, [_c('v-icon', {
    staticClass: "blue--text"
  }, [_vm._v("info")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "delegation-info"
  }, [_c('div', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm.$t('delegations.delegatedAs')))]), _vm._v(" "), _c('div', {
    staticClass: "blue--text text--lighten-1"
  }, [_vm._v(_vm._s(_vm.delegation.company.name))])]), _vm._v(" "), _c('v-flex', [_c('v-btn', {
    attrs: {
      "flat": "",
      "error": ""
    },
    on: {
      "click": function($event) {
        _vm.select(null)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')))])], 1)], 1)]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e5f9650","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Delegations.vue
// module id = 1064
// module chunks = 1